import { gql } from '@apollo/client';

import baseFields from '../base';

const CONTACTS_FRAGMENT = gql`
  fragment ContactsFragment on Contact {
    ${baseFields}
    number
    numberType
    type
  }
`;

export default CONTACTS_FRAGMENT;
